module.exports = __webpack_public_path__ + "static/media/recycled-materials.d018c703.png";